let __appNativeBridgeInstance;
const DEFAULT_TIMEOUT = 5 * 1000;
class MyTimeout {
    constructor() {
        this.set = (delay, reason) => new Promise((resolve, reject) => {
            const id = setTimeout(() => {
                if (reason === undefined)
                    resolve(null);
                else
                    reject(reason);
                this.clear(id);
            }, delay);
            this.ids.push(id);
        });
        this.wrap = (promise, delay, reason) => Promise.race([promise, this.set(delay, reason)]);
        this.clear = (...ids) => {
            this.ids = this.ids.filter(id => {
                if (ids.includes(id)) {
                    clearTimeout(id);
                    return false;
                }
                return true;
            });
        };
        this.ids = [];
    }
}
const fetch = (emitEvent, receiveEvent, args) => new Promise((resolve, reject) => {
    // fetch async event from webview interface
    if (!window || !window.nsWebViewInterface)
        reject('No webview interface found!');
    window.nsWebViewInterface.emit(emitEvent, args);
    window.nsWebViewInterface.once(receiveEvent, (data) => {
        // console.log('DEBUG fetch webview event', data)
        resolve(data);
    });
});
class AppNativeBridge {
    constructor() {
        if (!__appNativeBridgeInstance) {
            // eslint-disable-next-line @typescript-eslint/no-this-alias
            __appNativeBridgeInstance = this;
        }
        return this;
    }
    static emitEventToNativeApp(channel, data) {
        try {
            if (window && window.electron && window.electron.ipcRenderer) {
                window.electron.ipcRenderer.send(channel, data);
            }
            else if (window && window.nsWebViewInterface) {
                window.nsWebViewInterface.emit(channel, data);
            }
        }
        catch (error) {
            console.log(`Failed with reason: ${error}`);
        }
    }
    static async invokeEventToNativeApp(channel, data) {
        // Support desktop native app only
        if (window && window.electron && window.electron.ipcRenderer) {
            return await window.electron.ipcRenderer.invoke(channel, data);
        }
        else {
            throw new Error('Method not supported!');
        }
    }
    static listenEventFromNativeApp(channel, callback) {
        try {
            if (window && window.electron && window.electron.ipcRenderer) {
                window.electron.ipcRenderer.on(channel, (event, data) => callback(data));
            }
            else if (window && window.nsWebViewInterface) {
                window.nsWebViewInterface.on(channel, (data) => callback(data));
            }
        }
        catch (error) {
            console.log(`Failed with reason: ${error}`);
        }
    }
    static listenOnceEventFromNativeApp(channel, callback) {
        try {
            if (window && window.electron && window.electron.ipcRenderer) {
                window.electron.ipcRenderer.once(channel, (event, data) => callback(data));
            }
            else if (window && window.nsWebViewInterface) {
                window.nsWebViewInterface.once(channel, (data) => callback(data));
            }
        }
        catch (error) {
            console.log(`Failed with reason: ${error}`);
        }
    }
    static async getAppPreferences() {
        let appPref = null;
        try {
            if (window && window.electron) {
                appPref = await window.electron.getAppPreferences();
            }
            else if (window && window.nsWebViewInterface) {
                const timeout = new MyTimeout();
                try {
                    const data = await timeout.wrap(fetch('PreferencesReq:getAppPreferences', 'PreferencesRes:getAppPreferences', {}), DEFAULT_TIMEOUT, 'Fetch timeout!');
                    return Promise.resolve(data);
                }
                catch (error) {
                    console.log(`Failed with reason: ${error}`);
                    timeout.clear(...timeout.ids);
                    return Promise.reject(error);
                }
            }
        }
        catch (error) {
            return Promise.reject(error);
        }
        return Promise.resolve(appPref);
    }
    // Send request to the native app to get the pairing platform
    static async getSelectedPlatform() {
        let selected = null;
        try {
            if (window && window.electron) {
                selected = await window.electron.getPairedPlatform();
            }
            else if (window && window.nsWebViewInterface) {
                const timeout = new MyTimeout();
                try {
                    const data = await timeout.wrap(fetch('PreferencesReq:getSelectedPlatform', 'PreferencesRes:getSelectedPlatform', {}), DEFAULT_TIMEOUT, 'Fetch timeout!');
                    return Promise.resolve(data);
                }
                catch (error) {
                    console.log(`Failed with reason: ${error}`);
                    timeout.clear(...timeout.ids);
                    return Promise.reject(error);
                }
            }
        }
        catch (error) {
            return Promise.reject(error);
        }
        return Promise.resolve(selected);
    }
    static async getTrackerData() {
        let data = {};
        try {
            if (window && window.electron) {
                data = await window.electron.getTrackerData();
            }
            else if (window && window.nsWebViewInterface) {
                const timeout = new MyTimeout();
                try {
                    const data = await timeout.wrap(fetch('PreferencesReq:getTrackerData', 'PreferencesRes:getTrackerData', {}), DEFAULT_TIMEOUT, 'Fetch timeout!');
                    return Promise.resolve(data);
                }
                catch (error) {
                    console.log(`Failed with reason: ${error}`);
                    timeout.clear(...timeout.ids);
                    return Promise.reject(error);
                }
            }
        }
        catch (error) {
            return Promise.reject(error);
        }
        return Promise.resolve(data);
    }
    static async getGDPRPreferences() {
        let user = {};
        try {
            if (window && window.electron) {
                user = await window.electron.getGDPRPreferences();
            }
            else if (window && window.nsWebViewInterface) {
                const timeout = new MyTimeout();
                try {
                    const data = await timeout.wrap(fetch('PreferencesReq:getGDPRPreferences', 'PreferencesRes:getGDPRPreferences', {}), DEFAULT_TIMEOUT, 'Fetch timeout!');
                    return Promise.resolve(data);
                }
                catch (error) {
                    console.log(`Failed with reason: ${error}`);
                    timeout.clear(...timeout.ids);
                    return Promise.reject(error);
                }
            }
        }
        catch (error) {
            return Promise.reject(error);
        }
        return Promise.resolve(user);
    }
}
export default AppNativeBridge;
//# sourceMappingURL=common-bridge.js.map